const validImage10m = {
    NameFile: 'Elegir archivo (max 10 MB)',
    Peso: 6,
    MsgPeso: 'Solo se puede subir archivos menores a 10 MB',
    Formatos: /(\.jpg|\.jpeg|\.png|\.gif)$/i,
    MsgFormato: 'Extenciones permitidas .jpeg/.jpg/.png/.gif'
}

const validImage6m = {
    NameFile: 'Elegir archivo (max 6 MB)',
    Peso: 6,
    MsgPeso: 'Solo se puede subir archivos menores a 6 MB',
    Formatos: /(\.jpg|\.jpeg|\.png)$/i,
    MsgFormato: 'Extenciones permitidas .jpeg/.jpg/.png'
}

const validImage5m = {
    NameFile: 'Elegir archivo (max 5 MB)',
    Peso: 5,
    MsgPeso: 'Solo se puede subir archivos menores a 5 MB',
    Formatos: /(\.jpg|\.jpeg|\.png)$/i,
    MsgFormato: 'Extenciones permitidas .jpeg/.jpg/.png'
}

const validImage3m = {
    NameFile: 'Elegir archivo (max 3 MB)',
    Peso: 3,
    MsgPeso: 'Solo se puede subir archivos menores a 3 MB',
    Formatos: /(\.jpg|\.jpeg|\.png)$/i,
    MsgFormato: 'Extenciones permitidas .jpeg/.jpg/.png'
}

const validImage2m = {
    NameFile: 'Elegir archivo (max 2 MB)',
    Peso: 2,
    MsgPeso: 'Solo se puede subir archivos menores a 2 MB',
    Formatos: /(\.jpg|\.jpeg|\.png)$/i,
    MsgFormato: 'Extenciones permitidas .jpeg/.jpg/.png'
}

const validFile2m = {
    NameFile: 'Elegir archivo (max 2 MB)',
    Peso: 2,
    MsgPeso: 'Solo se puede subir archivos menores a 2 MB',
    Formatos: /(\.pdf|\.doc|\.docx|\.ppt|\.json)$/i,
    MsgFormato: 'Extenciones permitidas .pdf/.doc/.docx/.ppt/.json'
}

const validFile3m = {
    NameFile: 'Elegir archivo (max 3 MB)',
    Peso: 3,
    MsgPeso: 'Solo se puede subir archivos menores a 3 MB',
    Formatos: /(\.pdf|\.doc|\.docx|\.ppt|\.json)$/i,
    MsgFormato: 'Extenciones permitidas .pdf/.doc/.docx/.ppt/.json'
}

const validFile5m = {
    NameFile: 'Elegir archivo (max 5 MB)',
    Peso: 5,
    MsgPeso: 'Solo se puede subir archivos menores a 5 MB',
    Formatos: /(\.pdf|\.doc|\.docx|\.ppt|\.json)$/i,
    MsgFormato: 'Extenciones permitidas .pdf/.doc/.docx/.ppt/.json'
}

const configTolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    // ['blockquote', 'code-block'],
    [{ 'header': 1 }, { 'header': 2 }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],
    [{ 'indent': '-1' }, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }],
    [{ 'size': ['small', false, 'large', 'huge'] }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],
    // [{ 'font': [] }],
    [{ 'align': [] }],
    ['clean'],
    ['link'] //, 'image', 'video'
];

// FORMATEA LOS NUMEROS, AÑADE PREFIJO. PUEDE SER LLAMADA DESDE data() EN LAS INSTANCIAS DE VUE
const formatNumber = (num, prefix) => {
    num = Math.round(parseFloat(num) * Math.pow(10, 2)) / Math.pow(10, 2)
    prefix = prefix || '';
    num += '';
    let splitStr = num.split('.');
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? '.' + splitStr[1] : '.00';
    splitRight = splitRight + '00';
    splitRight = splitRight.substr(0, 3);
    let regx = /(\d+)(\d{3})/;

    while (regx.test(splitLeft)) {
        splitLeft = splitLeft.replace(regx, '$1' + ',' + '$2');
    }
    return prefix + splitLeft + splitRight;
}

const configEliminar = {
    title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea eliminar este registro?</h2>', //<h2 style="font-size:25px; font-weight: 700;">¿Desea eliminar esta información?</h2>
    text: 'Esta acción no se podra revertir ',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showLoaderOnConfirm: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configEliminarItem = {
    title: '<h2 style="font-size:25px; font-weight: 700;">Atención</h2>',
    text: '¿Confirma que desea eliminar la fila?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configEliminarConfirm = {
    title: '<h2 style="font-size:25px; font-weight: 700;">El registro ha sido eliminado.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const configCerrarSession = {
    title: '¿Cerrar Sesión?',
    text: 'Esta a punto de cerrar su sesión, ¿desea cerrarla?',
    icon: 'warning',
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configRestablecerPassword = {
    title: '¡Exito!',
    text: '¡Su contraseña ha sido reestablecida, ahora podra ingresar de nueva cuenta.!',
    icon: 'success',
    showCancelButton: false,
    showCloseButton: false,
    showLoaderOnConfirm: true,
}

const configEnviarRequisicion={
    title:'Enviar Requisición',
    text:'La solicitud de requisición será enviada para su revisión ¿Desea Continuar?',
    icon:'warning',
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configRecibirSolicitud={
    title:'Recibir Solicitud',
    text:'Está a punto de recibir la solicitud ¿Desea Continuar?',
    icon:'warning',
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configSolicitarAutorizacion={
    title:'Solicitar Autorización',
    text:'¿Desea enviar la requisición para su autorización?',
    icon:'warning',
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configSolicitarAutorizacionCompra={
    title:'Solicitar Autorización',
    text:'¿Desea enviar la compra para su autorización?',
    icon:'warning',
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configAutorizarCompra={
    title:'Autorizar Compra',
    text:'¿Desea continuar?',
    icon:'warning',
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configEnviarRequisicionConfirm = {
    title: '<h2 style="font-size:25px; font-weight: 700;">La requisición ha sido enviada.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const configRecibirSolicitudConfirm = {
    title: '<h2 style="font-size:25px; font-weight: 700;">La solicitud ha sido recibida.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const configSolicitarAutorizacionConfirm = {
    title: '<h2 style="font-size:25px; font-weight: 700;">La autorización ha sido solicitada.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const configAutorizarCompraConfirm = {
    title: '<h2 style="font-size:25px; font-weight: 700;">La compra ha sido autorizada.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const configPagarCuenta={
    title:'Pagar Cuenta',
    text:'¿Desea continuar?',
    icon:'warning',
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configPagarCuentaConfirm={
    title: '<h2 style="font-size:25px; font-weight: 700;">Cuenta Pagada Exitosamente.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const stylesTable = {
   StyleTh: 'text-uppercase text-secondary text-xxs font-weight-bolder opacity-7',
   StylePr: 'mb-0 text-sm text-capitalize ps-3',
   StyleTd: 'text-xs text-secondary mb-0',
}
const configMinMercancias = {
    title: 'Atención',
    text: 'Se debe agregar al menos 1 nodo a mercancias.',
    icon: 'warning',
    confirmButtonText: 'Aceptar',
    showCloseButton: true,
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
}
const configMinPedimentos = {
    title: 'Atención',
    text: 'Se debe agregar al menos 1 nodo en pedimentos',
    icon: 'warning',
    confirmButtonText: 'Aceptar',
    showCloseButton: true,
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
}
const configMaxRegistros = {
    title: '¡Atención!',
    text: 'Límite de registros alcanzado.',
    icon: 'warning',
    confirmButtonText: 'Aceptar',
    showCloseButton: true,
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
}
const configMinRemolques = {
    title: 'Atención',
    text: 'Debe agregar al menos un remolque.',
    icon: 'warning',
    confirmButtonText: 'Aceptar',
    showCloseButton: true,
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
}
const configMaxRemolques = {
    title: 'Atención',
    text: 'Se ha alcanzado el número máximo de remolques.',
    icon: 'warning',
    confirmButtonText: 'Aceptar',
    showCloseButton: true,
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
}

const configNoPermRemolques = {
    title: 'Atención',
    text: 'La configuración vehicular no admite remolques.',
    icon: 'warning',
    confirmButtonText: 'Aceptar',
    showCloseButton: true,
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
}
const configMinDestinos = {
    title: 'Atención',
    text: 'Se debe agregar al menos 1 nodo a destinos.',
    icon: 'warning',
    confirmButtonText: 'Aceptar',
    showCloseButton: true,
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
}
const configActivarPaquete = {
    title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea Activar el Paquete?</h2>', //<h2 style="font-size:25px; font-weight: 700;">¿Desea eliminar esta información?</h2>
    text: 'Esta acción no se podra revertir ',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showLoaderOnConfirm: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configActivarPaqueteConfirm = {
    title: '<h2 style="font-size:25px; font-weight: 700;">El Paquete ha sido Activado.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const configSuspenderPaquete = {
    title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea Suspender el Paquete?</h2>', //<h2 style="font-size:25px; font-weight: 700;">¿Desea eliminar esta información?</h2>
    text: 'Esta acción no se podra revertir ',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showLoaderOnConfirm: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configSuspenderPaqueteConfirm = {
    title: '<h2 style="font-size:25px; font-weight: 700;">El Paquete ha sido Suspendido.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const configCancelarPaquete = {
    title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea Cancelar el Paquete?</h2>', //<h2 style="font-size:25px; font-weight: 700;">¿Desea eliminar esta información?</h2>
    text: 'Esta acción no se podra revertir ',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showLoaderOnConfirm: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configCancelarPaqueteConfirm = {
    title: '<h2 style="font-size:25px; font-weight: 700;">El Paquete ha sido Cancelado.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}

const configAutorizarInventario={
    title:'Autorizar Inventario',
    text:'¿Desea continuar?',
    icon:'warning',
    confirmButtonText: 'Continuar',
    cancelButtonText: 'Cancelar',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: '#0096ED',
    cancelButtonColor: '#b92e27',
}

const configAutorizarInventarioConfirm={
    title: '<h2 style="font-size:25px; font-weight: 700;">Inventario Autorizado.</h2>',
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#0096ED',
    timer: 3000,
    timerProgressBar: true,
}
export default {
    validImage10m,
    validImage6m,
    validImage5m,
    validImage3m,
    validImage2m,
    validFile2m,
    validFile3m,
    validFile5m,
    configTolbarOptions,
    formatNumber,
    configEliminar,
    configEliminarItem,
    configEliminarConfirm,
    configCerrarSession,
    configRestablecerPassword,
    configEnviarRequisicion,
    configEnviarRequisicionConfirm,
    configRecibirSolicitud,
    configRecibirSolicitudConfirm,
    configSolicitarAutorizacion,
    configSolicitarAutorizacionConfirm,
    configSolicitarAutorizacionCompra,
    configAutorizarCompra,
    configAutorizarCompraConfirm,
    configPagarCuenta,
    configPagarCuentaConfirm,
    stylesTable,
    configMinMercancias,
    configMinPedimentos,
    configMaxRegistros,
    configMaxRemolques,
    configMinRemolques,
    configNoPermRemolques,
    configMinDestinos,
    configActivarPaquete,
    configActivarPaqueteConfirm,
    configSuspenderPaquete,
    configSuspenderPaqueteConfirm,
    configCancelarPaquete,
    configCancelarPaqueteConfirm,
    configAutorizarInventario,
    configAutorizarInventarioConfirm
}
